import React, { Component, Fragment } from "react";
import Config from "./Config";
import moment from "moment";
import { toast } from 'react-toastify';

const Helpers = {
    isEmpty: value => {
      return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
      );
	},
	getYear:(date)=>{
		return moment(date).year()
	},
	getMonth:(date)=>{
		
		var months = {
			0:"Jan",
			1:"Feb",
			3:"Mar",
			4:"Apr",
			5:"May",
			6:"Jun",
			7:"Jul",
			8:"Aug",
			9:"Sep",
			10:"Oct",
			11:"Nov",
			12:"Dec"

		}
		return months[moment(date).month()];
	},
	getDateInFormat: (date, dateFormat) => {
		dateFormat = dateFormat || Config.dateFormatInput;
		return moment(date).format(dateFormat);
	},
	getDateInInputFormat: (date, dateFormat) => {
		dateFormat = dateFormat || Config.dateFormatInputPost;
		return moment(date).format(dateFormat);
	},
	formatNumberComma(num, roundType) {
		var round = (typeof(roundType) != "undefined")?roundType:Config.roundFraction;		
		return this.formatNum({number:num,tooltip:false,preferFormat:false,round:round,includeZero:true});
	},
	amountFormat(num,originalNumber,fraction){
		// if(num == undefined || num == 0) return 0;
		if(num == undefined) return this.formatNum({number:0, originalNumber:0, round:0});
		fraction = fraction != null ? fraction:Config.roundAmount;
		console.log(Config.roundAmount,"+++");
		console.log(fraction,"====");
		return this.formatNum({number:num, preferFormat:true,originalNumber:originalNumber, round:fraction});
	},
    formatNum: numSet =>{
		  	var localSet = {
					  	number:0,
					  	originalNumber:0,
					  	preferFormat:true,
					  	round:Config.roundFraction,
					  	comma:Config.amountComma,
					  	currency:null,
					  	includeZero:false,
						fullNumber:false,
					  };



		   numSet = {
			   ...localSet,
			   ...numSet,
		   }
			
			if((numSet.number == 0 || numSet.number == null) && !numSet.includeZero ){
				return numSet.tooltip?'<font class="val" data-val="0" title="0">0</font>':0;
			}
			
			var number = parseFloat(numSet.number);	
			var original = numSet.originalNumber ? parseFloat(numSet.originalNumber) : number;
			var numeric = original;

			// maximum decimal places allowed is 6, so
			//originals are rounded off to maximum 6 digit to avoid discrepency while display
			original = original.toFixed(Config.maxFractionAllowed);
			if(original >= -0.000000 && original <= 0.000000){
				//if the difference is less than 6 digit accurate, consider 0
				original = 0;
			}

		
			if(numSet.preferFormat && Config.amountDivision > 0){
				console.log(number , Config.amountDivision,"inside")
				number = parseFloat(number / Config.amountDivision);
			}		
			if(numSet.round != null){
				
				if(number%1 == 0){
					// avoid fraction zeros
					// numSet.round = 0;
				}
				//number = number.toFixed(numSet.round);
				//number = parseFloat(toFixedNumber(number)) //Added to avoid E
				number = number.toFixed(numSet.round);
				if(number ==0) number =0;//TODO: to be checked for big numbers
				//original = original.toFixed(numSet.round);	
				
			}

			if(numSet.comma){
				var parts=number.toString().split(".");
				number = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
				
				var partsO = original.toString().split(".");
				original = partsO[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (partsO[1] ? "." + partsO[1] : "");
			}	
			if(numSet.preferFormat && Config.amountSymbol !=""){			
				number = number + Config.amountSymbol
			}
			
			if(numSet.tooltip ){
				 return '<font class="val titleTooltip" data-val="'+numeric+'" title="'+original+'">'+(numSet.currency != null ? numSet.currency+' ' : "" )+ number +"</font>"
			}else{
				return numSet.currency != null ? numSet.currency + " " +number : number;
			}
	},
	downloadFormURL(fileRepUniqueId,docType){
		return Config.apiUrl+"api/forms/download/"+fileRepUniqueId+"?token="+Config.jwt //+ "/type/"+docType;
	},
	viewFormURL(fileRepUniqueId,docType){
		return Config.apiUrl+"api/forms/view/"+fileRepUniqueId+"?token="+Config.jwt //+ "/type/"+docType;
	},downloadReportURL(fileRepUniqueId){
	return Config.apiUrl+"api/reports/download/"+fileRepUniqueId+"?token="+Config.jwt;
	}, viewReportURL(fileRepUniqueId){
		return Config.apiUrl+"api/reports/"+fileRepUniqueId+"?token="+Config.jwt;
	},
	downloadDocURL(fileRepUniqueId,docType){
		return Config.apiUrl+"api/"+docType+"/download/"+fileRepUniqueId+"?token="+Config.jwt //+ "/type/"+docType;
	},
	viewDocURL(fileRepUniqueId,docType){
		return Config.apiUrl+"api/"+docType+"/"+fileRepUniqueId+"?token="+Config.jwt //+ "/type/"+docType;
	},
	pushSuccess(msg){
		toast.success(msg, {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
		});
	},
	pushError(msg){
		toast.error(msg, {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			});
	},
	getParameterByName(name, url = window.location.href) {
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	},
	getFileIcon(fileName){
		var fileExt = fileName.split('.').pop();
		var icon = Config.fileIcons[fileExt];
		return icon;
	},
	getPageName(){
		//debugger;
		var parts = window.location.href.split('/');
	    var lastSegment = parts.pop() || parts.pop(); 
		return Config.pageNames[lastSegment]
	},
	isMobile(){
			const toMatch = [
				/Android/i,
				/webOS/i,
				/iPhone/i,
				/iPad/i,
				/iPod/i,
				/BlackBerry/i,
				/Windows Phone/i
			];
			
			return toMatch.some((toMatchItem) => {
				return navigator.userAgent.match(toMatchItem);
			});
	}
}
export default Helpers;
